import React from "react";
import SidebarLink from "./SidebarLink";

function SectionTitle({ label, isCollapsed, mobile = false }) {
  if (isCollapsed && !mobile) {
    return (
      <div className="mx-4 my-4 flex items-center justify-center">
        <div className="h-px w-full bg-slate-200 dark:bg-slate-800" />
      </div>
    );
  }

  return (
    <div className="px-4 pb-2 pt-5">
      <div className="flex items-center gap-3">
        <div className="h-px flex-1 bg-slate-200 dark:bg-slate-800" />
        <p className="shrink-0 text-[10px] font-bold uppercase tracking-[0.24em] text-slate-400 dark:text-slate-500">
          {label}
        </p>
        <div className="h-px flex-1 bg-slate-200 dark:bg-slate-800" />
      </div>
    </div>
  );
}

export default function SidebarSection({
  section,
  pathname,
  isCollapsed,
  mobile = false,
  onNavigate,
}) {
  if (!section?.items?.length) return null;

  return (
    <section className="mb-2">
      <SectionTitle
        label={section.label}
        isCollapsed={isCollapsed}
        mobile={mobile}
      />

      <nav className="space-y-1">
        {section.items.map((item) => (
          <SidebarLink
            key={item.path}
            item={item}
            pathname={pathname}
            isCollapsed={isCollapsed}
            mobile={mobile}
            onNavigate={onNavigate}
          />
        ))}
      </nav>
    </section>
  );
}